export default __webpack_public_path__ + "static/media/no-records.3e0f0b54.svg";